export default {
      id: "twitter-usage",
      viewBox: "0 0 631.5 512.55",
      url: __webpack_public_path__ + "img/icons.svg#twitter",
      toString: function () {
        return this.url;
      }
    }